import React from "react";

export const SkipLink = () => (
    <a href="#main-content" className="skip-link" data-testid="skip-to-content-link">
        Skip to main content
    </a>
);

export default SkipLink;
